<div class="wrapper-billing">
  <div class="section-title">
    <div class="row">
      <div class="col">
        <div class="d-flex align-items-center">
          <a
            routerLink="/dashboard/order-subscription"
            class="btn btn-back" [attr.aria-label]="'Back' | translate">
            <i class="fi-rr-arrow-alt-left"></i>
          </a>
          <div class="title" [attr.data-parent]="'Order Subscription' | translate">{{ "Order Subscription" | translate }}</div>
        </div>
      </div>
    </div>
  </div>

  <div class="section-main">
    <div class="row" *ngIf="dataIsLoading; else loadedContent">
      <div class="loading-spinner col-12 mt-5">
        <mat-spinner class="mx-auto mt-5" [diameter]="50"></mat-spinner>
      </div>
    </div>

    <ng-template #loadedContent>
      <div class="detail-title my-3">{{ "Customer Info" | translate }}</div>
      <div
        class="d-none d-md-none col-lg-12 d-lg-flex row order-card mx-0 my-2 p-0"
      >
        <div class="col-12 d-flex p-0">
          <div class="card-left col-6 p-0">
            <div class="row text-left m-0 p-0">
              <div class="col-8">
                <div class="value-text-large">
                  {{ subscripitonDetail.customerName }}
                </div>
                <div class="value-text-small">
                  {{ subscripitonDetail.customerMobilePrefix
                  }}{{ subscripitonDetail.customerMobile }}
                </div>
              </div>
              <div class="col-4">
                <span
                  class="badge badge-pill-clear mt-2 float-right"
                  [ngClass]="getStatus(subscripitonDetail.statusWord)?.class"
                  >{{
                    getStatus(subscripitonDetail.statusWord)?.display
                      | translate : [utils.translate(subscripitonDetail.status)]
                  }}</span
                >
              </div>
            </div>
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-8">
                <div
                  class="value-text mt-1"
                  *ngFor="
                    let data of subscripitonDetail.orderDetail.data;
                    let index = index
                  "
                >
                  {{ data.product_name }}
                </div>
              </div>
              <div class="col-4 d-flex flex-column align-items-end">
                <div class="value-text-large">
                  {{ subscripitonDetail.orderPrice }}
                  <span style="font-weight: 400 !important; color: #747e8b">
                    {{ subscripitonDetail.orderCurrency }}</span
                  >
                </div>
                <div class="value-text-small">
                  {{ subscripitonDetail.orderPv }}
                  <span style="font-weight: 400 !important; color: #747e8b">
                    PV</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="card-right col-6 p-0">
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Created Date" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.createdAt }}
                </div>
              </div>
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Next Recurring Date" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.nextRecurringDate }}
                </div>
              </div>
            </div>
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Day Left" | translate }}:
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.remainingDay }}
                </div>
              </div>
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Recurring Count" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.recurringCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-12 d-md-flex d-lg-none row order-card my-2 mx-0 p-0">
        <div class="col-12 d-flex flex-wrap p-0">
          <div class="card-top col-12 p-0">
            <div class="row text-left m-0 p-0">
              <div class="col-8">
                <div class="value-text-large">
                  {{ subscripitonDetail.customerName }}
                </div>
                <div class="value-text-small">
                  {{ subscripitonDetail.customerMobilePrefix
                  }}{{ subscripitonDetail.customerMobile }}
                </div>
              </div>
              <div class="col-4">
                <span
                  class="badge badge-pill-clear mt-2 float-right"
                  [ngClass]="getStatus(subscripitonDetail.statusWord)?.class"
                  >{{
                    getStatus(subscripitonDetail.statusWord)?.display
                      | translate : [utils.translate(subscripitonDetail.status)]
                  }}</span
                >
              </div>
            </div>
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-8">
                <div
                  class="value-text mt-1"
                  *ngFor="
                    let data of subscripitonDetail.orderDetail.data;
                    let index = index
                  "
                >
                  {{ data.product_name }}
                </div>
              </div>
              <div class="col-4 d-flex flex-column align-items-end">
                <div class="value-text-large">
                  {{ subscripitonDetail.orderPrice }}
                  <span style="font-weight: 400 !important; color: #747e8b">
                    {{ subscripitonDetail.orderCurrency }}</span
                  >
                </div>
                <div class="value-text-small">
                  {{ subscripitonDetail.orderPv }}
                  <span style="font-weight: 400 !important; color: #747e8b">
                    PV</span
                  >
                </div>
              </div>
            </div>
          </div>

          <div class="card-bottom col-12 p-0">
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Created Date" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.createdAt }}
                </div>
              </div>
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Next Recurring Date" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.nextRecurringDate }}
                </div>
              </div>
            </div>
            <div class="row text-left mx-0 my-2 p-0">
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Day Left" | translate }}:
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.remainingDay }}
                </div>
              </div>
              <div class="col-6">
                <div class="value-text" style="color: #747e8b">
                  {{ "Recurring Count" | translate }}
                </div>
                <div class="value-text">
                  {{ subscripitonDetail.recurringCount }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="detail-title my-3">{{ "History" | translate }}</div>
      <div
        class="d-none d-md-none col-lg-12 d-lg-flex row order-card mx-0 p-0 my-2"
      >
        <div class="col-12 d-flex p-0">
          <div class="col-12 card-history p-0">
            <div
              class="col-12 d-flex row justify-content-between p-4 m-0 history-border"
              *ngFor="let data of subscripitonDetail.detail; let index = index"
            >
              <div
                class="col-1 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Order ID" | translate }}
                </div>
                <div class="value-text">{{ data.orderId }}</div>
              </div>
              <div
                class="col-2 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Recurring Count" | translate }}
                </div>
                <div class="value-text">{{ data.recurringCount }}</div>
              </div>
              <div
                class="col-3 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Order detail" | translate }}
                </div>
                <div
                  class="value-text"
                  *ngFor="
                    let detail of data.orderDetail.data;
                    let index = index
                  "
                >
                  {{ detail.product_name }}
                </div>
              </div>
              <div
                class="col-1 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Order Price" | translate }}
                </div>
                <div class="value-text">
                  {{ data.orderPrice }}{{ data.orderCurrency }}
                </div>
                <div class="value-text">{{ data.orderPv }}PV</div>
              </div>
              <div
                class="col-1 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Status" | translate }}
                </div>
                <span
                  class="badge badge-pill mt-2"
                  [ngClass]="getStatus(data.orderStatusWord)?.class"
                  >{{
                    getStatus(data.orderStatusWord)?.display
                      | translate : [utils.translate(data.orderStatusWord)]
                  }}</span
                >
              </div>
              <div
                class="col-2 d-flex flex-wrap flex-column text-center m-0 p-0"
              >
                <div class="property-text">
                  {{ "Payment Date" | translate }}
                </div>
                <div class="value-text">{{ data.paidAt }}</div>
              </div>
              <div
                class="col-12 row d-flex justify-content-end p-0 my-2 mx-0"
                *ngIf="data.attachment.length != 0"
                style="border-top: 1px solid #f4f4f4"
              >
                <div
                  class="btn btn-primary mt-2"
                  (click)="openAttachement(data.attachment)"
                  (click)="openPDF(pdfContent)"
                >
                  {{ "CC Authorization Form" | translate }}
                </div>
              </div>
            </div>
          </div>

          <ng-template #pdfContent let-modal>
            <div class="modal-header">
              <h4 class="modal-title">PDF Viewer</h4>
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <iframe [src]="pdfSrc" width="100%" height="600px"></iframe>
            </div>
          </ng-template>
        </div>
      </div>
      <div class="col-md-12 d-md-flex d-lg-none row order-card mx-0 p-0 my-2">
        <div class="col-12 d-flex p-0">
          <div class="col-12 card-history p-0">
            <div
              class="col-12 d-flex row justify-content-between p-4 m-0 history-border"
              *ngFor="let data of subscripitonDetail.detail; let index = index"
            >
              <div class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0">
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Order ID" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <div class="value-text">{{ data.orderId }}</div>
                </div>
              </div>
              <div
                class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0 justify-content-between"
              >
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Recurring Count" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <div class="value-text">{{ data.recurringCount }}</div>
                </div>
              </div>
              <div
                class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0 justify-content-between"
              >
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Order detail" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <div
                    class="value-text text-right"
                    *ngFor="
                      let detail of data.orderDetail.data;
                      let index = index
                    "
                  >
                    {{ detail.product_name }}
                  </div>
                </div>
              </div>
              <div
                class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0 justify-content-between"
              >
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Order Price" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <div class="value-text">
                    {{ data.orderPrice }}{{ data.orderCurrency }}
                  </div>
                  <div class="value-text">{{ data.orderPv }}PV</div>
                </div>
              </div>
              <div
                class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0 justify-content-between"
              >
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Status" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <span
                    class="badge badge-pill mt-2"
                    [ngClass]="getStatus(data.orderStatusWord)?.class"
                    >{{
                      getStatus(data.orderStatusWord)?.display
                        | translate : [utils.translate(data.orderStatusWord)]
                    }}</span
                  >
                </div>
              </div>
              <div
                class="col-12 d-flex flex-wrap text-center mx-0 my-1 p-0 justify-content-between"
              >
                <div class="col-6 d-flex flex-wrap m-0 p-0">
                  <div class="property-text">
                    {{ "Payment Date" | translate }}
                  </div>
                </div>
                <div class="col-6 d-flex flex-wrap m-0 p-0 justify-content-end">
                  <div class="value-text">{{ data.paidAt }}</div>
                </div>
              </div>
              <div
                class="col-12 row d-flex justify-content-end p-0 my-2 mx-0"
                *ngIf="data.attachment.length != 0"
                style="border-top: 1px solid #f4f4f4"
              >
                <div
                  class="btn btn-primary mt-2"
                  (click)="openAttachement(data.attachment)"
                  (click)="openPDF(pdfContent)"
                >
                  {{ "CC Authorization Form" | translate }}
                </div>
              </div>
            </div>
          </div>

          <ng-template #pdfContent let-modal>
            <div class="modal-header">
              <h4 class="modal-title">PDF Viewer</h4>
              <button
                type="button"
                class="close"
                aria-label="Close"
                (click)="modal.dismiss('Cross click')"
              >
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <iframe [src]="pdfSrc" width="100%" height="600px"></iframe>
            </div>
          </ng-template>
        </div>
      </div>
    </ng-template>
  </div>
</div>
